<div class="text-align-center display-flex flex-direction-column">
  <h3 class="t-5@r color-void mb-4">{{ count | pluralize: 'Photo' : { skipNumberIfOne: true } }} Disapproved</h3>

  <div class="t-8@r color-ash mb-4">
    No nudity or unacceptable images.
    <br />
    Please follow the rules.
  </div>

  <div class="t-8@r font-weight-500 color-charcoal mb-6">Send new photos to {{ username }}</div>

  <button sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-blue-gradient'" (click)="confirm()">
    <sb-icon [name]="'photocamsolid'" />
    Upload Photos
  </button>
</div>
